var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"play-base"},[(_vm.videoPlayer.codingFormat === 0)?_c('video-play',{ref:"videoPlay",attrs:{"video-player":_vm.videoPlayer}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }